module.exports = __webpack_public_path__ + "img/gather_skirt.e5c282e4.png";